/**
 * Skip to Content Link
 * 
 * WCAG 2.4.1 compliance: Provides keyboard users a way to skip 
 * repetitive navigation and jump directly to main content.
 * 
 * The link is visually hidden until focused, then appears prominently.
 */

export const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="skip-to-content sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:font-medium"
    >
      Skip to main content
    </a>
  );
};
